import React from 'react';
import ReactDOM from 'react-dom/client';
import { bootstrapTabSession } from './services/tabSessionService';
import { initDesktopFileLogging } from './desktopFileLogging';
import App from './App';

bootstrapTabSession();
initDesktopFileLogging();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

